const { commitMutation, graphql } = require('react-relay/compat');

const mutation = graphql`
    mutation AddProcurementItemMutation($userId: String!, $input: ModifyProcurementItemsInput!) {
        modifyProcurementItems(input: $input) {
            items {
                id
                isInProcurement(userId: $userId)
            }
            portfolio {
                id
                items(first: 1) {
                    totalResults
                }
            }
        }
    }
`;

export default {
    commit: (environment, args) => {
        const {
            userId,
            itemIds,
            note,
            skipHoldRequest,
            onCompleted = () => {},
            onError = () => {},
        } = args;
        const input = {
            userId,
            note,
            action: 'ADD',
            itemIds,
            skipHoldRequest,
        };
        commitMutation(environment, {
            mutation,
            variables: { input, userId },
            onCompleted: (payload, errors) => {
                if (errors) {
                    onError(errors);
                    return;
                }
                onCompleted(payload);
            },
            onError,
        });
    },
};



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/ContactDealer/AddProcurementItemMutation.es.js